export default {
    chatArchives: 'Chat Archives',
    loadMore: 'Load More',
    empty: {
        before: 'No messages yet.',
        after: 'for a user to talk to :)',
    },
    markAllRead: 'Mark All Read',
    message: {
        title: 'PM with',
    },
    messages: 'Messages',
    messageSettings: 'Message Settings',
    noMatchingUsers: 'No matching users',
    noMessagesExchangedYet: 'No private messages exchanged yet...',
    privateMessagesBanned: 'Sorry, these private messages are banned',
    sendPrivateMessages: 'send private messages',
    settings: 'Settings',
    title: 'Private Messages',
    users: 'users',
    viewableConversation: 'for a viewable conversation.',
}
